//TODO: add options and move to sg-ui-components

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import DrawTicketForm from './DrawTicketForm';
import ScratchTicketForm from './ScratchTicketForm';
import { ContentBox, ContentBoxHead, ContentBoxBody, getCMSObject, CMSContent, IfLoggedIn, ErrorBoundary, TeleScript } from 'sg-ui-components';

import { mapDispatchToProps, mapStateToProps } from '../../Store';

/**********************************************************************
 * Component:  EnterTicketTabs
 * Purpose:    Simple tabbed component for Draw/Scratch and or
 *             other ticket types.
 *
 *             Will NOT show if user is not logged in.
 *
 * Props:       none
 *
 * APIs used:   none
 *
 *  Notes:
 */
const EnterTicketTabs = ({ cmsSourceFirebase, user, page, config }) => {
    const [activeTab, setActiveTab] = useState('scratch');
    const enterTicketTeleScript = getCMSObject('data.components.teleScripts.enterTickets.jsonBlock');
    useEffect(() => {
        return () => {
            setActiveTab('scratch');
        };
    }, []);

    return (
        <IfLoggedIn user={user}>
            <div className='enter-tickets-area'>
                <ContentBox variant='theme-primary'>
                    <ContentBoxHead>Enter Tickets</ContentBoxHead>
                    <ContentBoxBody>
                        <CMSContent
                            localStorageObject='webContent'
                            contentPath='data.webNotices'
                            className=''
                            noticePlacement='web-notice-ticket-entry'
                            cmsSourceFirebase={cmsSourceFirebase}
                            delayToShow={1000}>
                            {/* TODO: Refactor CMSContent webNotices, to reduce delayToShow                             
                            This keeps the entry form from showing, and then being hidden. The default is to show items and then hide them if there is a notice that should be shown. It just prevents users from seeing it and then it going away.
                            There is still the time required to calculate if the notice is active, current, and set for the current time. We're in favor of anything that will reduce this issue.                            
                            */}

                            <Tabs defaultActiveKey='scratch' id='enterTicketTabs' activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)} justify>
                                {config?.web?.features?.drawTickets ? (
                                    <Tab eventKey='draw' title={enterTicketTeleScript?.drawTixTabName ?? 'Draw Games'}>
                                        <ErrorBoundary
                                            fallback={<TeleScript line={enterTicketTeleScript?.drawFallback} />}
                                            details={{ page, user, config, ticketType: 'draw' }}>
                                            <DrawTicketForm />
                                        </ErrorBoundary>
                                    </Tab>
                                ) : null}

                                {config?.web?.features?.scratchTickets ? (
                                    <Tab eventKey='scratch' title={enterTicketTeleScript?.instantTixTabName ?? 'Scratchers'}>
                                        <ErrorBoundary
                                            fallback={<TeleScript line={enterTicketTeleScript?.scratchFallback} />}
                                            details={{ page, user, config, ticketType: 'scratch' }}>
                                            <ScratchTicketForm />
                                        </ErrorBoundary>
                                    </Tab>
                                ) : null}
                            </Tabs>
                        </CMSContent>
                    </ContentBoxBody>
                </ContentBox>
            </div>
        </IfLoggedIn>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterTicketTabs);
